import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderAnimationComponent } from './loader-animation.component';



@NgModule({
  declarations: [LoaderAnimationComponent],
  imports: [
    CommonModule
  ],
  exports: [LoaderAnimationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoaderAnimationModule { }
